// extracted by mini-css-extract-plugin
export var brandName = "Catalog-module--brandName--b8df3";
export var breadcrumbOverrides = "Catalog-module--breadcrumbOverrides--fc9ab";
export var categoryControls = "Catalog-module--categoryControls--bbe56";
export var categoryDescription = "Catalog-module--categoryDescription--bcbb6";
export var container = "Catalog-module--container--bac12";
export var filterBar = "Catalog-module--filterBar--3875f";
export var filterContainer = "Catalog-module--filterContainer--99d83";
export var fixedBase = "Catalog-module--fixedBase--f6f5f";
export var gridBody = "Catalog-module--gridBody--08711";
export var gridHeading = "Catalog-module--gridHeading--ef827";
export var noResults = "Catalog-module--noResults--37d5f";
export var productCards = "Catalog-module--productCards--352c5";
export var px0 = "Catalog-module--px0--34392";
export var px6 = "Catalog-module--px6--28132";
export var root = "Catalog-module--root--f9c13";
export var sortButton = "Catalog-module--sortButton--70d27";
export var stickyBase = "Catalog-module--stickyBase--3a695";